"use client";
/*
 * Documentation:
 * PRINT_DC_Card_Tabs — https://app.subframe.com/4f62853ee923/library?component=PRINT_DC_Card_Tabs_51dacbec-a85f-422d-b440-0c25344bc489
 */

import React from "react";
import { FeatherStar } from "@subframe/core";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";

interface ContentItemProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: React.ReactNode;
  text?: React.ReactNode;
  children?: React.ReactNode;
  title?: React.ReactNode;
  className?: string;
}

const ContentItem = React.forwardRef<HTMLDivElement, ContentItemProps>(
  function ContentItem(
    {
      icon = <FeatherStar />,
      text,
      children,
      title,
      className,
      ...otherProps
    }: ContentItemProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex flex-col items-start gap-4",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        <div className="flex items-center gap-2">
          {icon ? (
            <SubframeCore.IconWrapper className="text-body font-body text-subtext-color">
              {icon}
            </SubframeCore.IconWrapper>
          ) : null}
          {title ? (
            <span className="text-caption-bold font-caption-bold text-subtext-color">
              {title}
            </span>
          ) : null}
        </div>
        {children ? (
          <div className="flex flex-col items-start gap-6">{children}</div>
        ) : null}
      </div>
    );
  }
);

interface Print_Dc_Card_TabsRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const Print_Dc_Card_TabsRoot = React.forwardRef<
  HTMLDivElement,
  Print_Dc_Card_TabsRootProps
>(function Print_Dc_Card_TabsRoot(
  { children, className, ...otherProps }: Print_Dc_Card_TabsRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex flex-col items-start rounded-md",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {children ? (
        <div className="flex flex-col items-start gap-4">{children}</div>
      ) : null}
    </div>
  );
});

export const Print_Dc_Card_Tabs = Object.assign(Print_Dc_Card_TabsRoot, {
  ContentItem,
});
